import React from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText, Size as BodyTextSize } from '../../atoms/bodyText/BodyText'
import { BulletedList } from '../../atoms/bulletedList/BulletedList'
import { PrimaryButton } from '../../atoms/primaryButton/PrimaryButton'
import { Subhead } from '../../atoms/subhead/Subhead'
import { IS_WEB } from '../../constants'
import { SubheadSize, BodyTextSize as TypeBodyTextSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

interface RoiRecordsInfoViewProps {
  onClosePress: () => void
}

const RoiRecordsInfoViewContainer = styled.View<{ theme: ThemeType }>(({ theme: { spacing, breakpoints } }) => ({
  padding: breakpoints.isMobileSized ? spacing['16px'] : '0px',
}))

const Header = styled.View<{
  theme: ThemeType
}>(({ theme: { spacing } }) => ({
  paddingBottom: spacing['24px'],
  ...(IS_WEB && { cursor: 'default' }),
}))

const ContentContainer = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  paddingBottom: spacing['16px'],
}))

const ListContainer = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  paddingTop: spacing['4px'],
  paddingBottom: spacing['16px'],
}))

const ExcludesContainer = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  paddingBottom: spacing['24px'],
}))

const ButtonContainer = styled.View<{ theme: ThemeType }>(({ theme: { breakpoints } }) => ({
  ...(!breakpoints.isMobileSized && {
    width: 114,
    alignSelf: 'flex-end',
  }),
}))

export const RoiRecordsInfoView = ({ onClosePress }: RoiRecordsInfoViewProps) => {
  const { formatMessage } = useIntl()
  const { colors } = useTheme()

  const allRecordsList = [
    formatMessage({ defaultMessage: 'Client profile', description: 'All records list item' }),
    formatMessage({ defaultMessage: 'Intake form', description: 'All records list item' }),
    formatMessage({ defaultMessage: 'Initial intake form', description: 'All records list item' }),
    formatMessage({ defaultMessage: 'Pre-session and outcomes assessments', description: 'All records list item' }),
    formatMessage({ defaultMessage: 'Informed consent', description: 'All records list item' }),
    formatMessage({ defaultMessage: 'Care feedback forms', description: 'All records list item' }),
    formatMessage({ defaultMessage: 'Digital exercises and responses', description: 'All records list item' }),
    formatMessage({ defaultMessage: 'Sessions notes', description: 'All records list item' }),
    formatMessage({ defaultMessage: 'Attendance and cancellations', description: 'All records list item' }),
    formatMessage({ defaultMessage: 'Case referral and care feedback forms', description: 'All records list item' }),
  ]

  return (
    <RoiRecordsInfoViewContainer testID={tID('RoiRecordsInfoView')}>
      <Header>
        <Subhead
          size={SubheadSize.MEDIUM}
          text={formatMessage({
            defaultMessage: 'All records',
            description: 'All records modal header title',
          })}
        />
      </Header>
      <ContentContainer>
        <BodyText
          size={BodyTextSize.DEFAULT}
          color={colors.textPrimary}
          text={formatMessage({
            defaultMessage: 'Includes documents from your:',
            description: 'All records modal subtitle',
          })}
        />
        <ListContainer>
          <BulletedList
            data={allRecordsList.map((item) => ({ value: item }))}
            bulletAnnotation='·'
            size={TypeBodyTextSize.DEFAULT}
            spaceBetween={4}
            scrollEnabled={false}
          />
        </ListContainer>
      </ContentContainer>
      <ExcludesContainer>
        <BodyText
          size={BodyTextSize.DEFAULT}
          color={colors.textPrimary}
          text={formatMessage({
            defaultMessage: 'Excludes Treatment Summary Letter',
            description: 'All records modal excludes note',
          })}
        />
      </ExcludesContainer>
      <ButtonContainer>
        <PrimaryButton
          onPress={onClosePress}
          testID={tID('RoiRecordsInfoView-closeButton')}
          text={formatMessage({
            defaultMessage: 'Close',
            description: 'Close button label',
          })}
          fullWidth
        />
      </ButtonContainer>
    </RoiRecordsInfoViewContainer>
  )
}
